import React, { SyntheticEvent } from 'react';

export default function MusicAlbumFirstPageNextButton({
  onClick,
} : {
  onClick: () => void,
}) {
  const cancelEvent = (e: SyntheticEvent) => {
    e.preventDefault();
    e.stopPropagation();
  };

  return (
    <a
      className="bt"
      href="#"
      onClick={(e) => {
        cancelEvent(e);
        onClick();
      }
    }>
      次へ
    </a>
  );
}
